import { App } from "vue";
import TContainer from "@/components/core/TContainer.vue";
import TSection from "@/components/core/TSection.vue";
import DisplayAdapter from "@/components/core/DisplayAdapter.vue";

export function registerComponents(app: App) {
  app.component("TContainer", TContainer);
  app.component("TSection", TSection);
  app.component("DisplayAdapter", DisplayAdapter);
}
